import React from "react";
import "./CubeSpinner.scss";

const CubeSpinner = () => {
  return (
    <div className="loader-wrap" role="status" aria-label="Loading">
      <div className="loader">
        <div className="ring-middle" />
        <div className="ring-inner" />
      </div>
    </div>
  );
};

export default CubeSpinner;
